<div class="importacao-container">
  <!-- Seção: Vínculo com Empresa -->
  <section>
    <p class="section-title">VÍNCULO COM EMPRESA</p>

    <mat-form-field
      appearance="outline"
      class="full-width"
      [class.error]="touchedEmpresa && !empresaSelecionada"
    >
      <mat-label>Vincular empresa*</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="empresaDummyModel"
        name="empresaSelecionada"
        [value]="empresaSelecionada?.nomeFantasia || ''"
        readonly
        [disabled]="formBloqueado() || empresaSelecionada"
        (click)="!empresaSelecionada && abrirModalEmpresas()"
        [ngStyle]="!empresaSelecionada ? { cursor: 'pointer' } : {}"
      />
    </mat-form-field>

    <p
      *ngIf="touchedEmpresa && !empresaSelecionada"
      style="
        color: #ba1a1a;
        font-size: 12px;
        margin-top: -10px;
        margin-bottom: 20px;
      "
    >
      Empresa obrigatória
    </p>

    <div class="endereco-empresa-selecionada-card" *ngIf="empresaSelecionada">
      <p>{{ empresaSelecionada?.nomeFantasia }}</p>
      @if(!formBloqueado()) {
      <img
        src="../../../../assets/svg/icons/trash.svg"
        (click)="abrirDesvincularEmpresa()"
        style="cursor: pointer"
      />
      }
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Vincular endereço*</mat-label>
      <input
        matInput
        type="text"
        [value]="enderecoSelecionado?.labelEndereco || ''"
        readonly
        [disabled]="!empresaSelecionada || enderecoSelecionado"
        (click)="empresaSelecionada && !enderecoSelecionado && abrirModalEnderecos()"
        [ngStyle]="empresaSelecionada && !enderecoSelecionado ? { cursor: 'pointer' } : {}"
      />
    </mat-form-field>

    <p
      class="erro"
      *ngIf="touchedEndereco && empresaSelecionada && !enderecoSelecionado"
      style="
        color: #ba1a1a;
        font-size: 12px;
        margin-top: -10px;
        margin-bottom: 20px;
      "
    >
      Endereço obrigatório
    </p>

    <div class="endereco-empresa-selecionada-card" *ngIf="enderecoSelecionado">
      <p>{{ enderecoSelecionado.labelEndereco }}</p>

      @if(!formBloqueado()) {
      <img
        src="../../../../assets/svg/icons/trash.svg"
        (click)="abrirDesvincularEndereco()"
        style="cursor: pointer"
      />
      }
    </div>
  </section>

  <div style="height: 20px"></div>

  <!-- Seção: Upload de Arquivo -->
  <section class="form-section">
    <p class="section-title">ARQUIVO DE IMPORTAÇÃO</p>

    <!-- Botão Baixar Modelo -->
    <div class="modelo-container">
      <button matButton="filled" (click)="baixarPlanilhaModelo()">
        <mat-icon>download</mat-icon>
        <span>Baixar planilha modelo</span>
      </button>

      <span class="modelo-hint">
        Baixe a planilha modelo e preencha com os dados dos trabalhadores.
      </span>
    </div>

    <!-- Input de Arquivo -->
    <div class="upload-area">
      <input
        type="file"
        id="fileInput"
        accept=".xlsx,.xls"
        (change)="onArquivoSelecionado($event)"
        [disabled]="processando"
        hidden
      />

      <!-- Área de upload quando não há arquivo -->
      <div
        *ngIf="!arquivoSelecionado()"
        class="upload-placeholder"
        [class.error]="touchedArquivo && !arquivoSelecionado()"
        (click)="!processando && abrirSeletorArquivo()"
        [style.cursor]="processando ? 'not-allowed' : 'pointer'"
      >
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="upload-text">
          Clique para selecionar ou arraste o arquivo aqui
        </p>
        <p class="upload-hint">Apenas arquivos .xlsx ou .xls (máximo 10MB)</p>
      </div>

      <!-- Card do arquivo selecionado -->
      <div *ngIf="arquivoSelecionado()" class="arquivo-selecionado">
        <div class="arquivo-content">
          <mat-icon class="arquivo-icon">description</mat-icon>
          <div class="arquivo-info">
            <p class="arquivo-nome">{{ arquivoSelecionado()?.name }}</p>
            <p class="arquivo-tamanho">
              {{ formatarTamanhoArquivo(arquivoSelecionado()?.size || 0) }}
            </p>
          </div>
          <button
            mat-icon-button
            (click)="removerArquivo()"
            [disabled]="processando"
            class="btn-remover"
            *ngIf="!formBloqueado()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Mensagem de erro de arquivo -->
      <p *ngIf="touchedArquivo && !arquivoSelecionado()" class="error-message">
        Arquivo obrigatório
      </p>
    </div>
  </section>

  <!-- Seção: Progresso -->
  <section class="form-section" *ngIf="processando">
    <p class="section-title">PROCESSANDO IMPORTAÇÃO</p>
    <mat-progress-bar mode="determinate" [value]="progresso"></mat-progress-bar>
    <p class="progresso-text">{{ progresso }}% concluído</p>
  </section>

  <!-- Seção: Resultado da Importação -->
  <section>
    <div *ngIf="resultadoImportacao" class="resultado-importacao">
      <p class="section-title">RESULTADO DA IMPORTAÇÃO</p>

      <mat-accordion>
        <mat-expansion-panel hideToggle style="pointer-events: none">
          <mat-expansion-panel-header>
            <mat-panel-title class="accordion-title">
              @if(resultadoImportacao.status === 'FINALIZADO_COM_ERRO') {
              <img
                src="../../../../assets/svg/icons/eva_intensa_ic.svg"
                alt=""
              />
              Importação Concluída com Erros } @if(resultadoImportacao.status
              === 'FINALIZADO_SUCESSO') {
              <img src="../../../../assets/svg/icons/eva_baixa_ic.svg" alt="" />
              Importação Concluída com Sucesso } @if(resultadoImportacao.status
              === 'ERRO_FATAL') {
              <img
                src="../../../../assets/svg/icons/eva_intensa_ic.svg"
                alt=""
              />
              Erro Fatal na Importação }
            </mat-panel-title>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="status-message">
        <!-- FINALIZADO COM ERROS -->
        @if (resultadoImportacao.status === 'FINALIZADO_COM_ERRO') {
        <p>
          Foram importados
          <strong>{{ resultadoImportacao.linhasValidas }}</strong> cadastros com
          sucesso, porém
          <strong>{{ resultadoImportacao.linhasComErro }}</strong> cadastros
          apresentaram erros.
        </p>

        <p>
          Você pode baixar o relatório de erros para verificar os detalhes e
          corrigir os dados antes de realizar uma nova importação.
        </p>

        <button
          mat-stroked-button
          color="primary"
          (click)="baixarRelatorioErros()"
        >
          <mat-icon>download</mat-icon>
          Baixar Relatório de Erros
        </button>
        }

        <!-- FINALIZADO COM SUCESSO -->
        @if (resultadoImportacao.status === 'FINALIZADO_SUCESSO') {
        <p>
          <strong>{{ resultadoImportacao.linhasValidas }}</strong> cadastros
          foram importados com sucesso.
        </p>

        <p>Nenhum erro foi identificado durante o processamento do arquivo.</p>
        }

        <!-- ERRO FATAL -->
        @if (resultadoImportacao.status === 'ERRO_FATAL') {
        <p>
          Ocorreu um erro fatal durante a importação e nenhum cadastro foi
          processado.
        </p>

        <p>Verifique o arquivo enviado ou tente novamente mais tarde.</p>
        }
      </div>
    </div>
  </section>

  <!-- Botões de Ação -->
  <div class="actions-container">
    <button mat-stroked-button (click)="cancelar()" [disabled]="processando">
      {{ resultadoImportacao ? 'Voltar' : 'Cancelar' }}
    </button>

    <div class="actions-right">
      <button
        *ngIf="resultadoImportacao"
        mat-stroked-button
        color="primary"
        (click)="novaImportacao()"
      >
        Nova Importação
      </button>

      <button
        *ngIf="!resultadoImportacao"
        mat-flat-button
        color="primary"
        (click)="processarImportacao()"
        [disabled]="processando || !formularioValido()"
      >
        <mat-icon>upload</mat-icon>
        Processar Importação
      </button>
    </div>
  </div>
</div>
